"use client";

/**
 * @deprecated Import from '@/hooks/settings' instead
 * This file re-exports for backward compatibility
 */

export {
  useTenantSettings,
  useEmailAutoReplySettings,
  useBodyIdentityOverrideSettings,
  useShopifyAttributionSettings,
  useEconomicsSettings,
} from './settings/use-tenant';

export type {
  TenantSetting,
  EmailAutoReplySettings,
  ShopifyAttributionSettings,
  EconomicsSettings,
} from './settings/use-tenant';
